import { render, staticRenderFns } from "./EmployeesList.vue?vue&type=template&id=6740327d&scoped=true&"
import script from "./EmployeesList.vue?vue&type=script&lang=js&"
export * from "./EmployeesList.vue?vue&type=script&lang=js&"
import style0 from "./EmployeesList.vue?vue&type=style&index=0&id=6740327d&scoped=true&lang=css&"
import style1 from "@/assets/styles/modal.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6740327d",
  null
  
)

component.options.__file = "EmployeesList.vue"
export default component.exports